import React, { Component } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { createComponent as cc } from 'react-fela';

const COLORS = ['#00C49F', '#FF8042', '#0088FE'];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  // eslint-disable-next-line
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  // eslint-disable-next-line
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  // eslint-disable-next-line
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};
const PieChartWrapper = cc(
  () => ({
    margin: '0 auto',
  }),
  PieChart,
  ['width', 'height'],
);

class UserFeedbackChart extends Component {
  render() {
    const data = [
      { name: 'Positive', value: this.props.positive },
      { name: 'Negative', value: this.props.negative },
      { name: 'neutral', value: this.props.neutral },
    ];
    return (
      <PieChartWrapper height={400} width={400}>
        <Pie
          data={data}
          dataKey="value"
          fill="#8884d8"
          label={renderCustomizedLabel}
          labelLine={false}
        >
          {data.map((entry, index) => (
            <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChartWrapper>
    );
  }
}

export default UserFeedbackChart;



// WEBPACK FOOTER //
// ./src/components/userDetail/UserFeedbackChart.js